import copyToClipboard from 'common/utilities/browser/copyToClipboard/copyToClipboard';
import { copyToClipboardAction } from 'core/redux/actions/ui/uiActions';
import type {
AnyAction,
  Middleware, } from 'redux';

const copyToClipboardMiddleware: Middleware = () => (next) => (action: AnyAction) => {
  if (copyToClipboardAction.match(action)) {
    copyToClipboard(action.payload.content);
  }

  next(action);
};

export default copyToClipboardMiddleware;
